// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"style_homeContainer__2RLad","moduleSection":"style_moduleSection__2zq8d","chip":"style_chip__STYqX"};